import type { FC, ReactNode } from "react";
import { DownloadExcelContainer, SearchContainer } from "app/pages/workspace/StyledComponent";
import { translate } from "app/filters/i18nFilter";
import { Right } from "app/components/React/TopSites/DomainsTable/Styled";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { DownloadButtonMenu } from "app/components/React/DownloadButtonMenu/DownloadButtonMenu";
import { swSettings } from "app/common/services/swSettings";
import { getColumnsPickerLiteProps } from "app/pages/keyword-analysis/common/UtilityFunctions";
import { ColumnsPickerLite } from "@similarweb/ui-components";
import { SearchInput } from "@similarweb/ui-components";
import { isPaidExcelAllowed } from "app/services/PaidExcelService/isPaidExcelAllowed";
import { getExcelButtonText } from "app/components/React/ExcelButton/getExcelButtonText";

interface ISearchAndUtils {
    search: string;
    onSearchChange: (search: string) => void;
    excelLink: string;
    tableColumns: Array<unknown>;
    onClickToggleColumns: (field: string, columns?: any[]) => void;
    AddToDashboard?: ReactNode;
    totalCount?: number;
    hasPaidExcel?: boolean;
}

/**
 * Render search input, download excel button, columnsSelection, and add to dashboard [if provided].
 */
export const SearchAndUtils: FC<ISearchAndUtils> = (props) => {
    const {
        search,
        onSearchChange,
        excelLink,
        tableColumns,
        onClickToggleColumns,
        AddToDashboard,
        totalCount,
        hasPaidExcel,
    } = props;
    const isPaidExcelPermitted = isPaidExcelAllowed();
    return (
        <SearchContainer>
            <SearchInput
                clearValue={false}
                defaultValue={search}
                debounce={400}
                onChange={onSearchChange}
                placeholder={translate("forms.search.placeholder")}
            />
            <Right>
                <FlexRow>
                    <DownloadExcelContainer>
                        <DownloadButtonMenu
                            iconNameProps={!swSettings.current.resources.IsExcelAllowed ? "excel-download" : null}
                            Excel={true}
                            downloadUrl={excelLink}
                            excelLocked={!swSettings.current.resources.IsExcelAllowed}
                            PaidExcel={isPaidExcelPermitted ? hasPaidExcel : null}
                            totalCount={totalCount}
                            buttonText={getExcelButtonText()}
                        />
                    </DownloadExcelContainer>
                    <div>
                        <ColumnsPickerLite
                            {...getColumnsPickerLiteProps(tableColumns, onClickToggleColumns)}
                            withTooltip
                            extendedDropdown
                            translations={{
                                tooltip: translate("workspace.sales.column.picker"),
                                getSelectedAmountText: ({ selectedValue, totalValue }) =>
                                    translate("common.columnsPicker.selectedAmount", {
                                        selected: selectedValue,
                                        total: totalValue,
                                    }),
                                mandatoryField: translate("common.columnsPicker.mandatoryField"),
                                apply: translate("common.apply"),
                            }}
                        />
                    </div>
                    {AddToDashboard}
                </FlexRow>
            </Right>
        </SearchContainer>
    );
};
